import { routes as concreto } from './concreto';

export default [
  {
    path: '/concreto',
    name: 'concretodefault',
    description: 'Concreto',
    icon: 'uil-betoneira',
    children: [...concreto],
    customChildren: ['Cadastro', 'Relatórios']
  }
];
